import { render, staticRenderFns } from "./LookupValueCpt.vue?vue&type=template&id=3b0ac85a&"
import script from "./LookupValueCpt.vue?vue&type=script&lang=ts&"
export * from "./LookupValueCpt.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports